module.exports = __webpack_public_path__ + "img/inactive-11.2107dd8b.svg";